export default __webpack_public_path__ + "static/media/Snd_LowerVSlideup.25beae56.mp3";